module.exports = __webpack_public_path__ + "img/cross-platform-logo.e7bdee53.svg";